// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import Vuetify from 'vuetify';
import router from './router';
import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';
import VeeValidate from 'vee-validate';
import colors from 'vuetify/es5/util/colors';
import Truncate from 'lodash.truncate';
import * as VueGoogleMaps from 'vue2-google-maps';
import HighchartsVue from 'highcharts-vue';
import highchartsMore from 'highcharts/highcharts-more';
import highchartsFunnel from 'highcharts/modules/funnel';
import highchartsSunburst from 'highcharts/modules/sunburst';
import Highcharts from 'highcharts';
import VueGtag from 'vue-gtag';

highchartsMore(Highcharts);
highchartsFunnel(Highcharts);
highchartsSunburst(Highcharts);

import store from './store';

Vue.config.productionTip = false;
Vue.use(VueGtag, {
  config: { id: process.env.NODE_ENV === 'production' ? 'KVLKWY27EN' : '' }
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCX2t7ooOeE3RCIUieCD4IYaJ9jmr_Ui-M',
    // key: "AIzaSyBxJR5ecu50qJGWBFm7bY2bkOwPZAa4wfI",
    libraries: 'places'
  }
});
Vue.use(require('vue-moment'));
Vue.use(HighchartsVue, {
  Highcharts,
  tagName: 'charts'
});
Vue.filter('truncate', Truncate);
Vue.use(VeeValidate, {
  fieldsBagName: 'formFields'
});

Vue.use(Vuetify, {
  theme: {
    primary: process.env.PRIMARY,
    secondary: process.env.SECUNDARY,
    info: process.env.INFO
  },
  options: {
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: process.env.PRIMARY,
      },
      sideToolbar: {},
      sideNav: process.env.PRIMARY,
      mainNav: process.env.PRIMARY,
      bodyBg: '',
    }
  }
});

const app = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
});

require('./util/axios');



// WEBPACK FOOTER //
// ./src/main.js